import * as Definitions from "./Definitions";
import { Observable } from "rxjs";
import { Effects } from "../";
export const description = "Adds a coupon by code to a specified cart.";
export const method = "PUT";
export const operationId = "quoteCouponManagementV1SetPut";
export const path = "/V1/carts/mine/coupons/{couponCode}";
export interface PathParams {
    couponCode: string;
}
export type Response = Response200 | Response400 | Response401 | ResponseDefault;
export type Response200 = boolean;
export type Response400 = Definitions.ErrorResponse;
export type Response401 = Definitions.ErrorResponse;
export type ResponseDefault = Definitions.ErrorResponse;
type MinimalEffects = Pick<Effects, "apiUrl" | "restHeaders" | "putJSON">;
export function execute(pathParams: PathParams, effects: MinimalEffects): Observable<Response200> {
    return effects.putJSON(effects.apiUrl(operationId)(path, pathParams), null, effects.restHeaders({})) as any;
}
